import ProductSearch        from './components/product-search.vue';
import ProductView          from './components/replacement/product-view.vue';
import ProductTraces        from './components/product-traces.vue';
import MoneyField       from '@/components/fields/money-field.vue';
import BarcodeReaderInput   from '@/components/fields/barcode-reader-input.vue';

import { validationMixin } from 'vuelidate';
import { required, requiredIf, maxLength} from 'vuelidate/lib/validators';

export default {
    components : {
        ProductSearch,
        ProductView,
        ProductTraces,
        BarcodeReaderInput,
        MoneyField,
    },
    mixins: [validationMixin],

    validations: {
        checkboxNoSerialNumber : {
            checked (val) {
                let barcode = this.$refs.barcodeReaderInput.getValue();
                if (barcode && barcode.length > 0 && val) {
                    return true;
                } else if (!val) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        selectProductPackage: { required },
        checkboxNoTraces : {
            checked (val) {
                if (this.checkboxProductTraces.length > 0 || this.othersProductTraces.length > 0 || val) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        checkboxProductTraces : {
            required : requiredIf(function (model) {
                if (this.othersProductTraces.length > 0 || this.checkboxNoTraces || this.checkboxProductTraces.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
        },
        othersProductTraces    : {
            required : requiredIf(function (model) {
                if (this.checkboxProductTraces.length > 0 || this.checkboxNoTraces || this.othersProductTraces.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
            maxLength : maxLength(200)
        },
        checkboxNoAccessoires : {
            checked (val) {
                if (this.checkboxesProductAccessoires.length > 0 || this.othersProductAccessoires.length > 0 || val) {
                    return true;
                } else {
                    return false;
                }
            },
        },
        checkboxesProductAccessoires : {
            required : requiredIf(function (model) {
                if (this.othersProductAccessoires.length > 0 || this.checkboxNoAccessoires || this.checkboxesProductAccessoires.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
        },
        othersProductAccessoires    : {
            required : requiredIf(function (model) {
                if (this.checkboxesProductAccessoires.length > 0 || this.checkboxNoAccessoires || this.othersProductAccessoires.length > 0) {
                    return false;
                } else {
                    return true;
                }
            }),
            maxLength : maxLength(200)
        },
        panelProductInformation : [
            'checkboxNoSerialNumber',
        ],
        panelProductTraces      : [
            'checkboxNoTraces',
            'checkboxProductTraces',
            'othersProductTraces'
        ],
        panelProductAccessoires : [
            'checkboxNoAccessoires',
            'checkboxesProductAccessoires',
            'othersProductAccessoires'
        ],
        stepProductReplacement         : [
            'panelProductInformation',
            'panelProductTraces',
            'panelProductAccessoires'
        ]
    },

    props: {
        jsonDebug   :  {
            type    : Boolean,
            default : true
        },
    },
    data() {
        return {
            selectedReplacementProduct          : null,
            toggleProductReplacement            : false,
            selectedReplacementProductTraces    : [
                { label: 'Kratzspuren am Gehäuse', id : '000'},
                { label: 'Riss im Display',        id : '001'},
                { label: 'Farbschaden',            id : '002'},
                { label: 'Delle in Gehäuse',       id : '003'},
                { label: 'Riss im Gehäuse',        id : '004'}
            ],
            selectedReplacementProductAccessoires    : [
                { label: 'Monitor',                       id : '010'},
                { label: 'Lautsprecher',                  id : '011'},
                { label: 'Batterie/Akku',                 id : '012'},
                { label: 'Netzgeräte',                    id : '013'},
                { label: 'originalverpackt und komplett', id : '014'},
                { label: 'ohne Zubehör',                  id : '015'},
                { label: 'Ladegerät',                     id : '016'},
                { label: 'Akku',                          id : '017'}
            ],
            // defines wich panel will be opend on start
            // 0 - ProductInformation
            // 1 - ProductTraces
            // 2 - ProductAccessoires
            panelsProductData       : [0, 1, 2],
            panelProductInformation : null,
            panelProductTraces      : null,
            panelProductAccessoires : null,

            showProductInfos        : false,
            selectedProductInfos    : [],

            //Fields
            fieldSerialNumber       : "",
            fieldSerialNumberHint   : "capture",
            checkboxNoSerialNumber  : true,

            checkboxProductTraces   : [],
            othersProductTraces     : "",
            checkboxNoTraces        : false,
            productTracesOptions: [
                { label: 'Kratzspuren am Gehäuse', id : '000'},
                { label: 'Riss im Display',        id : '001'},
                { label: 'Farbschaden',            id : '002'},
                { label: 'Delle in Gehäuse',       id : '003'},
                { label: 'Riss im Gehäuse',        id : '004'}
            ],

            //accessoires
            checkboxesProductAccessoires  : [],
            othersProductAccessoires    : "",
            checkboxNoAccessoires        : false,
            productAccessoiresOptions   : [
                { label: 'Monitor',                       id : '010'},
                { label: 'Lautsprecher',                  id : '011'},
                { label: 'Batterie/Akku',                 id : '012'},
                { label: 'Netzgeräte',                    id : '013'},
                { label: 'originalverpackt und komplett', id : '014'},
                { label: 'ohne Zubehör',                  id : '015'},
                { label: 'Ladegerät',                     id : '016'},
                { label: 'Akku',                          id : '017'}
            ],
        };
    },

    methods: {
        getStepData() {
            let ret = {};
            if (!this.selectedReplacementProduct) {
                return ret;
            }

            ret.replacementDeviceSet   = this.toggleProductReplacement;
            let replacementDevice = {};
            replacementDevice.inventoryNumber  = selectedReplacementProduct.inventoryNumber;
            replacementDevice.serialNumber     = selectedReplacementProduct.serialNumber;
            replacementDevice.price            = this.$salePrice.getValue();
            replacementDevice.productName      = productViewData.productName;
            ret.replacementDevice = replacementDevice;

            let traces = {};
            traces.tracesNone      = this.checkboxNoTraces;
            traces.traces          = this.checkboxProductTraces;
            traces.tracesOtherText = this.othersProductTraces;
            ret.traces = traces;

            let accessories = {};
            accessories.accessoriesNone       = this.checkboxNoAccessoires;
            accessories.accessories           = this.checkboxesProductAccessoires;
            accessories.accessoriesOtherText  = this.othersProductAccessoires;
            ret.accessories = accessories;

            return ret;
        },
        getStepSubmitData() {
            let ret = {};
            if (!this.selectedReplacementProduct) {
                return ret;
            }

            ret.replacementDeviceSet   = this.toggleProductReplacement;
            let replacementDevice = {};
            replacementDevice.inventoryNumber  = selectedReplacementProduct.inventoryNumber;
            replacementDevice.serialNumber     = selectedReplacementProduct.serialNumber;
            replacementDevice.price            = this.$salePrice.getValue();
            replacementDevice.productName      = productViewData.productName;
            ret.replacementDevice = replacementDevice;

            let traces = {};
            traces.tracesNone      = this.checkboxNoTraces;
            traces.traces          = this.checkboxProductTraces;
            traces.tracesOtherText = this.othersProductTraces;
            ret.traces = traces;

            let accessories = {};
            accessories.accessoriesNone       = this.checkboxNoAccessoires;
            accessories.accessories           = this.checkboxesProductAccessoires;
            accessories.accessoriesOtherText  = this.othersProductAccessoires;
            ret.accessories = accessories;

            return ret;
        },
        onSerialNumberCheckboxClick() {
            if (!this.checkboxNoSerialNumber) {
                this.$refs.barcodeReaderInput.setValue('');
            }
        },
        checkSerialNumberIfHintOrNot() {
            if(this.checkboxNoSerialNumber) {
                this.fieldSerialNumberHint = "scan";
                return false;
            }
            this.fieldSerialNumberHint = "not-available";
            return true;
        },
        onCheckboxNoTracesChange() {
            this.validateStep();
            this.checkboxProductTraces = [];
            this.othersProductTraces = "";
        },
        onCheckboxNoAccessoiresChange() {
            this.validateStep();
            this.checkboxesProductAccessoires = [];
            this.othersProductAccessoires = "";
        },
        onSelectProduct(product) {
            if (product != null) {
                this.selectedReplacementProduct = product;
                this.$emit('step-product-replacement-is-valid');
                this.$emit('on-product-select-change', product);

                //load product details
                this.showProductInfos = true;
                this.selectedProduct = product;
                this.selectedProductInfos = [];
                let productInfos = {};
                productInfos =  {
                    'detail'    : product.inventorynumber,
                    'label'     : 'inventory-number'
                };
                this.selectedProductInfos.push(productInfos);
                productInfos =  {
                    'detail'    : product.eannumber,
                    'label'     : 'ean-number'
                };
                this.selectedProductInfos.push(productInfos);
                productInfos =  {
                    'detail'    : product.brandName,
                    'label'     : 'brand-name'
                };
                this.selectedProductInfos.push(productInfos);
                productInfos =  {
                    'detail'    : product.name[this.$i18n.locale],
                    'label'     : 'model-name'
                };
                this.selectedProductInfos.push(productInfos);
            } else {
                this.showProductInfos       = false;
            }
        },
        onClearSelectedProduct() {
            this.resetValues();
            this.$v.$reset();
            // this.$v.stepProductReplacement.$reset();
        },
        resetValues() {
            console.info('reset values');
            this.selectedProductInfos   = [];
            this.showProductInfos       = false;

            this.$refs.barcodeReaderInput.setValue();
            this.checkboxNoSerialNumber = false;
            this.selectProductPackage   = "";

            this.checkboxProductTraces  = [];
            this.othersProductTraces    = "";
            this.checkboxNoTraces       = false;
        },
        validateAll() {
            //validate all fields
            this.$v.stepProductReplacement.$touch();
            this.$refs.barcodeReaderInput.validate();

            let errorKeys = [];

            //panelProductInformation (Key = 0)
            if (this.$v.panelProductInformation.$anyError) {
                errorKeys.push(0); // push key to errorKey to expand panel
            }

            //panelProductTracesKey (Key = 1)
            if (this.$v.panelProductTraces.$anyError) {
                errorKeys.push(1);  // push key to errorKey to expand panel
            }

            //panelProductTracesKey (Key = 2)
            if (this.$v.panelProductAccessoires.$anyError) {
                errorKeys.push(2);  // push key to errorKey to expand panel
            }

            this.panelsProductData = [];
            if (errorKeys.length > 0) {
                this.panelsProductData = errorKeys;
                return false;
            }
            return true;
        },
        validateSelectedProduct() {
            if (!this.$refs.productSearch.validate()) {
                this.$emit('step-product-replacement-has-errors');
                return false;
            }
            this.$emit('step-product-replacement-is-valid');
            return true;
        },
        validateStep() {
            if (this.validateSelectedProduct()){
                return false;
            }
            if(!this.$v.stepProductReplacement.$dirty) {
                return;
            } else {
                this.$v.stepProductReplacement.$touch();
                this.$refs.barcodeReaderInput.validate();
            }

        },
        getProductTraces() {
            let ret = [];
            let me = this;
            this.checkboxProductTraces.forEach(function(trace) {
                ret.push(trace.id);
            });
            return ret;
        },
        getProductAccessoires() {
            let ret = [];
            let me = this;
            this.checkboxesProductAccessoires.forEach(function(accessoire) {
                ret.push(accessoire.id);
            });
            return ret;
        },
        isProductReplacementEnable() {
            return this.toggleProductReplacement;
        }
    },
    watch: {
        '$v.stepProductReplacement.$anyError' : function(errors) {
            console.warn('#############', errors);
            if (errors) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing xxx
                this.$emit('step-product-replacement-has-errors');
            } else {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('step-product-replacement-is-valid');
            }
        },
        '$v.stepProductReplacement.$dirty' : function(dirty) {
            if (!dirty && !this.$v.stepProductReplacement.$anyError) {
                // Fire when the form is cleared
                // @arg The argument is a boolean value representing
                this.$emit('step-product-replacement-is-valid');
            } else {
                if (this.$v.stepProductReplacement.$anyError) {
                    // Fire when the form is cleared
                    // @arg The argument is a boolean value representing xxx
                    this.$emit('step-product-replacement-has-errors');
                }
            }
        },
    },
    computed: {
        //push errors for if case
        selectedProductErrors () {
            const errors = [];
            if (!this.$v.selectedProduct.$dirty) {
                return errors;
            }
            if (!this.$v.selectedProduct.required) {
                errors.push('selectedProduct is required');
            }
            return errors;
        },
        checkboxNoSerialNumberErrors () {
            const errors = [];
            if (!this.$v.checkboxNoSerialNumber.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxNoSerialNumber.checked) {
                errors.push('checkboxNoSerialNumber is required.');
            }
            return errors;
        },
        selectProductPackageErrors () {
            const errors = [];
            if (!this.$v.selectProductPackage.$dirty) {
                return errors;
            }
            if(!this.$v.selectProductPackage.required) {
                errors.push('Package Select is required');
            }
            return errors;
        },
        checkboxNoTracesErrors () {
            const errors = [];
            if (!this.$v.checkboxNoTraces.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxNoTraces.checked) {
                errors.push('');
            }
            return errors;
        },
        checkboxProductTracesErrors () {
            const errors = [];
            if (!this.$v.checkboxProductTraces.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxProductTraces.required) {
                errors.push('');
            }
            return errors;
        },
        othersProductTracesErrors () {
            const errors = [];
            if (!this.$v.othersProductTraces.$dirty) {
                return errors;
            }
            if(!this.$v.othersProductTraces.maxLength) {
                errors.push('othersProductTraces must be at most 50 characters long');
            }
            if(!this.$v.othersProductTraces.required) {
                errors.push('');
            }
            return errors;
        },
        checkboxNoAccessoiresErrors () {
            const errors = [];
            if (!this.$v.checkboxNoAccessoires.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxNoAccessoires.checked) {
                errors.push('');
            }
            return errors;
        },
        checkboxesProductAccessoiresErrors () {
            const errors = [];
            if (!this.$v.checkboxesProductAccessoires.$dirty) {
                return errors;
            }
            if(!this.$v.checkboxesProductAccessoires.required) {
                errors.push('');
            }
            return errors;
        },
        othersProductAccessoiresErrors () {
            const errors = [];
            if (!this.$v.othersProductAccessoires.$dirty) {
                return errors;
            }
            if(!this.$v.othersProductAccessoires.maxLength) {
                errors.push('othersProductAccessoires must be at most 50 characters long');
            }
            if(!this.$v.othersProductAccessoires.required) {
                errors.push('');
            }
            return errors;
        },
    },
};
